import { render, staticRenderFns } from "./InventoryRoomOverlay.vue?vue&type=template&id=6a88492c&"
import script from "./InventoryRoomOverlay.vue?vue&type=script&lang=ts&"
export * from "./InventoryRoomOverlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports